import { FilePdfOutlined } from '@ant-design/icons'
import { theme } from 'antd'

import { Document, Page } from './reactPdf'
import { rejectPasswordProtectedPdf } from './pdfPassword'
import { FilePlaceholder } from './FilePlaceholder'
import type { FileStatus } from './useDisplaySources'

const thumbStyle = (selected: boolean): React.CSSProperties => ({
  width: 50,
  height: 50,
  cursor: 'pointer',
  borderRadius: 4,
  flexShrink: 0,
  border: selected ? '2px solid #1677ff' : '2px solid transparent',
})

type DocumentThumbnailProps = {
  src: string | null
  status: FileStatus
  isPdf: boolean
  selected: boolean
  rotate: number
  onClick: () => void
}

export const DocumentThumbnail = ({
  src,
  status,
  isPdf,
  selected,
  rotate,
  onClick,
}: DocumentThumbnailProps) => {
  const { token } = theme.useToken()

  if (status !== 'ready' || !src) {
    return (
      <div
        onClick={onClick}
        style={{
          ...thumbStyle(selected),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: token.colorFillTertiary,
        }}
      >
        <FilePlaceholder status={status} compact />
      </div>
    )
  }
  if (isPdf) {
    return (
      <div
        onClick={onClick}
        title="PDF document"
        style={{
          ...thumbStyle(selected),
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: token.colorFillTertiary,
          color: token.colorError,
        }}
      >
        <div style={{ lineHeight: 0, transform: `rotate(${rotate}deg)` }}>
          <Document
            file={src}
            loading={null}
            error={<FilePdfOutlined style={{ fontSize: 24 }} />}
            onPassword={rejectPasswordProtectedPdf}
          >
            <Page
              pageNumber={1}
              width={50}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        </div>
      </div>
    )
  }
  return (
    <img
      src={src}
      onClick={onClick}
      style={{
        ...thumbStyle(selected),
        objectFit: 'cover',
        transform: `rotate(${rotate}deg)`,
      }}
    />
  )
}
